module.exports = __webpack_public_path__ + "media/images/company/cp12-0ef82247db6226d780742d81ac56e242.png";